var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSliderVertical = function SvgSliderVertical(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.47401 5.33333H10.5266C10.8747 5.33333 11.1835 5.34095 11.4586 5.36761C12.9351 5.47809 13.3337 5.95047 13.3337 7.23809V8.7619C13.3337 10.0495 12.9351 10.5219 11.4586 10.6324C11.1835 10.659 10.8747 10.6667 10.5266 10.6667H5.47401C5.12594 10.6667 4.81717 10.659 4.54208 10.6324C3.06559 10.5219 2.66699 10.0495 2.66699 8.7619V7.23809C2.66699 5.95047 3.06559 5.47809 4.54208 5.36761C4.81717 5.34095 5.12594 5.33333 5.47401 5.33333Z",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3.33333H13",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 12.6667H13.333",
    stroke: "currentColor",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSliderVertical;